"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.toastVariants = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _CheckCircleOutline = _interopRequireDefault(require("@material-ui/icons/CheckCircleOutline"));

var _ErrorOutline = _interopRequireDefault(require("@material-ui/icons/ErrorOutline"));

var _Warning = _interopRequireDefault(require("@material-ui/icons/Warning"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));

var _styles = require("@material-ui/core/styles");

var _iconVariant;

var toastVariants = {
  primary: 'PRIMARY',
  success: 'SUCCESS',
  error: 'ERROR',
  warning: 'WARNING'
};
exports.toastVariants = toastVariants;
var useStyles = (0, _styles.makeStyles)(function () {
  var _ref;

  return _ref = {
    "default": {
      color: 'var(--color-text-dark)'
    }
  }, (0, _defineProperty2["default"])(_ref, toastVariants.primary, {
    color: 'var(--color-primary)'
  }), (0, _defineProperty2["default"])(_ref, toastVariants.success, {
    color: 'var(--color-green)'
  }), (0, _defineProperty2["default"])(_ref, toastVariants.error, {
    color: 'var(--color-red)'
  }), (0, _defineProperty2["default"])(_ref, toastVariants.warning, {
    color: 'var(--color-orange)'
  }), (0, _defineProperty2["default"])(_ref, "message", {
    flex: 1
  }), (0, _defineProperty2["default"])(_ref, "root", {
    backgroundColor: 'var(--color-bg-card)',
    border: '1px solid var(--color-divider)',
    borderRadius: '99999px',
    boxShadow: 'none'
  }), _ref;
});
var iconVariant = (_iconVariant = {}, (0, _defineProperty2["default"])(_iconVariant, toastVariants.primary, _CheckCircleOutline["default"]), (0, _defineProperty2["default"])(_iconVariant, toastVariants.success, _CheckCircleOutline["default"]), (0, _defineProperty2["default"])(_iconVariant, toastVariants.error, _ErrorOutline["default"]), (0, _defineProperty2["default"])(_iconVariant, toastVariants.warning, _Warning["default"]), _iconVariant);

var _default = function _default(_ref2) {
  var variant = _ref2.variant,
      message = _ref2.message,
      onClose = _ref2.onClose,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["variant", "message", "onClose"]);
  var classes = useStyles();
  var Icon = iconVariant[variant];
  return /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], (0, _extends2["default"])({}, props, {
    onClose: onClose
  }), /*#__PURE__*/_react["default"].createElement(_SnackbarContent["default"], {
    classes: {
      root: classes.root,
      message: classes.message
    },
    message: /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('flex items-center', (0, _get["default"])(classes, variant, classes['default']))
    }, !(0, _isNil["default"])(Icon) && /*#__PURE__*/_react["default"].createElement(Icon, {
      className: "mr-2"
    }), message),
    action: /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      size: "small",
      onClick: onClose
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-gray-light"
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      color: "inherit"
    })))
  }));
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map